import { z } from 'zod';
export const updateProfileSchema = z.object({
    fullName: z.string().min(2).max(120).trim().optional(),
    jobTitle: z.string().max(120).trim().nullable().optional(),
    avatarUrl: z.string().url().nullable().optional(),
});
//# sourceMappingURL=user.contract.js.map